import 'shared/global';
import 'components/subnav';
import 'vendor/twitter.widgets';

import textSizesSwitcher from 'shows/textSizesSwitcher';
import 'components/social/SocialShare';
import skyboxClosedCheck from 'components/skyboxClosedCheck';

textSizesSwitcher({
    target: '#js-news-detail-content',
});

$('.social__container').SocialShare();

//temporary having ad team add skybox-closed class
skyboxClosedCheck({
    target: document.getElementById('scroll_prestitial'),
});
